import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import ReactDataSheet from 'react-datasheet';
import './react-datasheet.css';
import {translate} from "react-i18next";
import {generateId} from '../../../store/auth/utils'
import {trimValues, getBrowserInfo} from 'utils'


const customContentStyle = {
    // height: '90%',
    // maxWidth: 'none',
};


class MassImportDialog extends Component {
    state = {}

    constructor(props) {
        super(props)
        const grid = []
        const header = [
            {value: props.foreignLang.native_name, readOnly: true, width: 200},
            {value: props.nativeLang.native_name, readOnly: true, width: 200},
            {value: props.t('package_management_example_sentence'), readOnly: true, width: 300}
        ]
        grid.push(header)
        if (props.initGrid) {
            for (let i = 0; i < props.initGrid.length; i++) {
                grid.push(props.initGrid[i])
            }
        }
        for (let i = 0; i < 50; i++) {
            grid.push(MassImportDialog.generateEmptyRow());
        }
        this.state = {
            grid,
        }
    }

    resetGrid = () => {
        const header = [...this.state.grid[0]]
        const grid = []
        grid.push(header)
        for (let i = 0; i < 50; i++) {
            grid.push(MassImportDialog.generateEmptyRow());
        }
        this.setState({grid})

    }

    handleClose = () => {
        this.resetGrid()
        this.props.onClose()
    }


    handleSave = () => {
        const isValidCard = (card) => {
            if (card.f_word === "" || card.f_word === null || card.f_word.length > 100) return false;
            if (card.n_word === "" || card.n_word === null || card.n_word.length > 100) return false;
            if (card.example && card.example.length > 300) return false;
            return true;
        }

        const isEmptyLine = (card) => {
            return (card.n_word === null || card.n_word === "") && (card.f_word === null || card.f_word === "") && (card.example === null || card.example === "")
        }

        const cards = []
        const grid = this.state.grid
        let localIncrement = this.props.auth.localIncrement
        let invalidCardsCount = 0
        for (let i = 1; i < grid.length; i++) {
            const values = trimValues({f_word: grid[i][0].value, n_word: grid[i][1].value, example: grid[i][2].value})

            if (isValidCard(values)) {
                const id = generateId(this.props.auth.deviceId, localIncrement++);
                const card = {...values, id, package_id: this.props.package.id};
                cards.push(card)
            }
            else {
                if (!isEmptyLine(values)) {
                    invalidCardsCount++
                }
            }
        }
        if (cards.length > 0) {
            this.props.setLocalIncrement(localIncrement)
            this.props.addCards(cards)
        }
        if (invalidCardsCount > 0) {
            alert(this.props.t('mass_import_warning_skipped_lines', {1: invalidCardsCount}))
        }
        this.handleClose()
    }


    static generateEmptyRow = () => {
        return Array(3).fill({value: ''});
    }

    static isLastLineEmpty = (grid) => {
        const lastRow = grid[grid.length - 1];
        for (let i = 0; i < 3; i++) {
            if (lastRow[i].value !== '') {
                return false
            }
        }
        return true
    }


    onCellsChanged = (changes, additions) => {
        const grid = this.state.grid.map(row => [...row])
        const updateGrid = (changes) => {
            changes.forEach(({cell, row, col, value}) => {
                grid[row][col] = {...grid[row][col], value}
            })
        };
        updateGrid(changes)
        let maxRow = -1
        if (additions) {
            additions.forEach(({cell, row, col, value}) => {
                if (row > maxRow) {
                    maxRow = row;
                }
            })
            const addRows = maxRow + 1 - grid.length
            for (let i = 0; i < addRows; i++) {
                grid.push(MassImportDialog.generateEmptyRow())
            }
            updateGrid(additions);
        }
        if (!MassImportDialog.isLastLineEmpty(grid)) {
            grid.push(MassImportDialog.generateEmptyRow()) // always add one extra line

        }
        this.setState({grid})
    }


    render() {
        const browserName = getBrowserInfo().name
        const actions = [
            <FlatButton
                label={this.props.t('dialog_dismiss')}
                primary={false}
                onClick={this.handleClose}
            />,
            <FlatButton
                label={this.props.t('mass_import_dialog_save')}
                primary={true}
                onClick={this.handleSave}
            />,
        ];
        if (browserName === 'IE') {
            return (
                <Dialog open={this.props.open} actions={[actions[0]]} title={this.props.t('mass_import_dialog_title')}>
                    <p>{this.props.t('unsupported_browser')}</p>
                </Dialog>
            )
        }
        return (
            <Dialog
                autoScrollBodyContent={true}
                title={this.props.t('mass_import_dialog_title')}
                actions={actions}
                modal={true}
                contentStyle={customContentStyle}
                open={this.props.open}
                repositionOnUpdate={true}
                autoDetectWindowHeight={true}
            >
                <div style={{marginTop: '20px'}}>
                    <p style={{fontSize: '14px'}}>{this.props.t('mass_import_ctrl_v_for_multiple_lines_insert')}</p>
                    <ReactDataSheet
                        data={this.state.grid}
                        valueRenderer={(cell) => cell.value}
                        onCellsChanged={this.onCellsChanged}
                    />
                </div>
            </Dialog>
        )

    }
}

MassImportDialog.propTypes = {
    foreignLang: PropTypes.object,
    nativeLang: PropTypes.object,
    package: PropTypes.object,
    open: PropTypes.bool.isRequired
};
MassImportDialog.defaultProps = {};


export default translate()(MassImportDialog)



// WEBPACK FOOTER //
// ./src/components/packages/mass_import/MassImportDialog.js